angular.module('jv.Dashboard.Canvas.Application.Controller', [])
.controller('jv.Dashboard.Canvas.Application.Controller', ['$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService','$rootScope',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $rootScope) {

    $scope.refreshTimestamp = true;
    //Handler for refresh_widget
    $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
        if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
            $scope.refreshTimestamp = false;
            $scope.refresh = true;
            fetchCanvasApplicationData();
        }
    });

    var widgetObject = $scope.widgetObject;

    $scope.analyticsData = [];
    // $scope.analyticsData = [10, 100];
    $scope.analyticsChartType = 'pie';
    $scope.analyticsLabels = ['With Chat', 'Without Chat'];

    var fetchCanvasApplicationData = function(){
        jvContextualLoadingService.hide($scope.widgetObject.widgetId);
        $scope.refreshTimestamp = true;

        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.fetchCanvasApplicationData({}, function(response) {
            $scope.analyticsData = [];
            if (response && response.subAggregation) {
                var count = response.count;
                angular.forEach(response.subAggregation, function(value) {
                    $scope.analyticsData.push(value.count);
                });
            }
            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
            $scope.refreshTimestamp = true;
        });
    };
    fetchCanvasApplicationData();
}]);
